module.exports = __webpack_public_path__ + "img/complex.940b4274.svg";